<template>
<el-form :model="userInfoFormData" label-position="top" :rules="rules" ref="userInfoForm">
  <div class="title-h4">계정 및 역할 정보</div>
  <el-row :gutter="20">
    <el-col :span="12">
      <el-form-item label="아이디" prop="managerId">
        <el-input v-if="popupType === 'add'" v-model="userInfoFormData.managerId" placeholder="입력해 주세요."></el-input>
        <el-input v-else v-model="userInfoFormData.managerId" placeholder="입력해 주세요." :disabled="true"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="이름" prop="managerName">
        <el-input v-model="userInfoFormData.managerName" placeholder="입력해 주세요."></el-input>
      </el-form-item>
    </el-col>
  </el-row>
  <el-row :gutter="20">
    <el-col :span="12">
      <el-form-item label="역할" prop="managerType">
        <span slot="label">
             역할 <i class="fas fa-info-circle" style="cursor: pointer;" @click="clickManagerTypeInfo"></i>
          </span>
        <el-select v-model="userInfoFormData.managerType" style="width:100%">
          <el-option v-for="item in managerTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="계정 잠금" prop="lockStatus">
        <el-switch v-model="userInfoFormData.lockStatus" active-value="1" inactive-value="0" style="height:28px"></el-switch>
      </el-form-item>
    </el-col>
  </el-row>
  <el-row :gutter="20">
    <div v-show="popupType === 'add'">
      <el-col :span="12">
        <el-form-item label="비밀번호" prop="password">
          <el-input type="password" v-model="userInfoFormData.password" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="비밀번호 확인" prop="passwordConfirm">
          <el-input type="password" v-model="userInfoFormData.passwordConfirm" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div v-show="popupType === 'update'">
      <el-col :span="12" v-show="policyObject.PASSWORDCHANGINGTYPE !== 'PASSWORDINIT'">
        <el-form-item label="비밀번호">
          <el-button style="width:100%;height:28px" @click="changePassword">비밀번호 변경</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-show="policyObject.PASSWORDCHANGINGTYPE === 'PASSWORDINIT'">
        <el-form-item label="비밀번호">
          <el-button style="width:100%;height:28px" @click="initPassword">비밀번호 초기화</el-button>
        </el-form-item>
      </el-col>
    </div>

  </el-row>
  <div class="title-h4 mr-t25">기본 정보</div>
  <el-row :gutter="20">
    <el-col :span="16">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="소속" prop="association">
            <el-input v-model="userInfoFormData.association" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="부서" prop="department">
            <el-input v-model="userInfoFormData.department" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="직급" prop="grade">
            <el-input v-model="userInfoFormData.grade" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="사번" prop="empno">
            <el-input v-model="userInfoFormData.empno" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="모바일" prop="mobileNumber">
            <el-input v-model="userInfoFormData.mobileNumber" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="내선번호" prop="telNumber">
            <el-input v-model="userInfoFormData.telNumber" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="8">
      <img class="myimage" :src="userInfoFormData.managerPhoto" />
      <el-upload action="" :before-upload="(file) => file" :auto-upload="false" :show-file-list="false" :on-change="changeUserImage" style="width:100%">
        <el-button size="small" type="primary" style="width:100%">사진 업로드</el-button>
      </el-upload>
    </el-col>
  </el-row>
  <el-row>
    <el-form-item label="E-Mail" prop="email">
      <el-input v-model="userInfoFormData.email" placeholder="address@watchtek.co.kr"></el-input>
    </el-form-item>
  </el-row>
  <!-- 접근 IP 설정 -->
  <div class="mr-t25">
    <div class="title-bar title-h4">접근 허용 IP 설정</div>
    <el-form-item class="veritcal-center-box" prop="addAccessAllowIp">
      <div style="width: 30px; margin-top: 5px; float: left">
        <label class="mr-r15">IP</label></div>
      <div style="width: 260px; margin:1px 3px 0 0; float: left">
        <el-input style="top:-1px;width:260px;" v-model="addAccessAllowIp" @keyup.native.enter="onAddAccessAllowIp" placeholder="입력해 주세요."></el-input>
      </div>
      <div style="width: 50px; float:left">
        <el-button size="mini" @click="onAddAccessAllowIp" type="primary">추가</el-button>
      </div>
    </el-form-item>
    <el-table-wrapper :data="accessAllowIps" :columns="columns" :column-default="columnDefault" :pagination="false">
      <template slot-scope="scope" slot="remove-slot">
      <i class="fal fa-times c-pointer" @click="onClickDeleteAccessAllowIp(scope)"></i>
    </template>
    </el-table-wrapper>
  </div>
</el-form>
</template>

<script>
import { cloneDeep, isNil, isEmpty, isEqual, join } from 'lodash';
import { validateEmailAddr, validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
import { isUnauthorizedFile, isImageFile } from '@/utils/file';
import { MSG_UPLOAD_UNAUTHORIZED_FILE, MSG_UPLOAD_IMAGE_ONLY } from '@/constants/file';
import { columnDefault } from '@/constants/table';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import UserSettingAPI from '@/api/settings/user/user-setting';

export default {
  name: 'WUserInfoForm',
  props: {
    popupType: String,
    selectedUserInfo: Object,
  },
  watch: {
    selectedUserInfo: {
      immediate: true,
      handler(object) {
        this.userInfoFormData = cloneDeep(object);
        if (!isEmpty(this.userInfoFormData.accessAllowIp)) {
          const ipList = this.userInfoFormData.accessAllowIp.split(',');
          this.accessAllowIps = ipList.map((item) => ({ ipaddress: item }));
        }
      },
    },
  },
  data() {
    const validateId = (rule, value, callback) => {
      if (isEqual(this.popupType, 'add')) {
        if (isNil(value) || isEqual(value.length, 0)) {
          callback(new Error('필수 정보입니다.'));
        } else {
          const reg = new RegExp(/^[_A-Za-z0-9+]*$/);
          if (!reg.test(value)) {
            callback(new Error('영어, 숫자, _와 같은 문자만 사용할 수 있습니다.'));
          }
          UserSettingAPI.checkIdValidation({
            managerId: value,
          }).then((response) => {
            const result = response.data.data;
            if (isEqual(result, 'success')) {
              callback();
            } else if (isEqual(result, 'active')) {
              callback(new Error('이미 사용 중인 아이디입니다.'));
            } else if (isEqual(result, 'inactive')) {
              callback(new Error('비활성화 된 아이디입니다.'));
            } else {
              callback(new Error('네트워크 통신이상.'));
            }
          });
        }
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (isEqual(this.popupType, 'add')) {
        if (isNil(value) || isEqual(value.length, 0)) {
          callback(new Error('필수 정보입니다.'));
        } else {
          const passwordPolicy = this.policyObject;
          if (isEqual(passwordPolicy.SETPASSWORDPOLICY, 1)) {
            // 비밀번호 정책 적용 여부
            let reg = null;
            if (isEqual(passwordPolicy.ALLOWSPECIALCHARACTER, 0)) {
              // 특수 문자 허용 여부
              const pattern = '[~!@#$%<>^&*()=+_’;."\']';
              reg = new RegExp(pattern, 'ig');
              if (!(isNil(value) || !reg.test(value))) {
                callback(new Error('특수문자는 허용하지 않습니다.'));
              }
            } else if (isEqual(passwordPolicy.ALLOWSPECIALCHARACTER, 1)) {
              // 특수 문자 허용 여부
              const pattern = '[~!@#$%<>^&*()=+_’;."\']';
              reg = new RegExp(pattern, 'ig');
              if (!(isNil(value) || reg.test(value))) {
                callback(new Error('특수문자와 함께 조립해 주세요.'));
              }
            }
            if (isEqual(passwordPolicy.COMBINATIONCHECK, 1)) {
              // 문자, 숫자 조합
              const strPattrn = '([ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z])';
              const numPattern = '([0-9])';
              const regStr = new RegExp(strPattrn, 'ig');
              const regNum = new RegExp(numPattern, 'ig');
              reg = regStr.test(value) && regNum.test(value);
              if (!(isNil(value) || reg)) {
                callback(new Error('문자와 숫자를 조합해 주세요.'));
              }
            }
            // FIXME 패턴 정규식 이상하여 다시 추가해야됨
            // if (isEqual(passwordPolicy.SECURITYWEAKPATTERNCHECK, 1)) {
            //   //패턴
            //   let securetyPattern = passwordPolicy.PATTERN;
            //   securetyPattern = securetyPattern.substring(0, securetyPattern.length - 1);
            //   const pattern = securetyPattern.replace(/;/g, '|');
            //   reg = new RegExp(pattern, 'ig');
            //
            //   if (!(isNil(value) || !reg.test(value))) {
            //     callback(new Error('너무 쉬운 패턴 입니다.'));
            //   }
            // }
            if (passwordPolicy.USE_MINIMUMLENGTH === 1) {
              // 최소 길이
              if (!(value.length >= passwordPolicy.MINIMUMLENGTH)) {
                callback(new Error(`비밀번호의 길이는 ${passwordPolicy.MINIMUMLENGTH}자 이상 입니다.`));
              }
            }
            if (passwordPolicy.USE_MAXIMUMLENGTH === 1) {
              // 최대 길이
              if (!(value.length <= passwordPolicy.MAXIMUMLENGTH)) {
                callback(new Error(`비밀번호의 길이는 ${passwordPolicy.MAXIMUMLENGTH}자 이하 입니다.`));
              }
            }
            if (isEqual(passwordPolicy.ALLOWPASSWORDIDDUPLICATE, 1)) {
              // ID포함 여부
              const managerId = this.userInfoFormData.id;
              const pattern = managerId;
              reg = new RegExp(pattern, 'ig');
              if (!(isNil(value) || !reg.test(value) || isNil(managerId))) {
                callback(new Error('ID를 포함할 수 없습니다.'));
              }
            }
            if (isEqual(passwordPolicy.ALLOWPRIVATEINFO, 1)) {
              // 전화번호 포함 여부
              const telNumber = this.userInfoFormData.telNumber;
              const pattern = telNumber;
              reg = new RegExp(pattern, 'ig');
              if (!(isNil(value) || !reg.test(value) || isNil(telNumber))) {
                callback(new Error('전화번호를 포함할 수 없습니다.'));
              }
            }
            if (isEqual(passwordPolicy.ALLOWPRIVATEINFO, 1)) {
              // 사번 포함 여부
              const empno = this.userInfoFormData.empno;
              const pattern = empno;
              reg = new RegExp(pattern, 'ig');
              if (!(isNil(value) || !reg.test(value) || isNil(empno))) {
                callback(new Error('사번을 포함할 수 없습니다.'));
              }
            }
          }
        } callback();
      } else {
        callback();
      }
    };
    const validatePasswordConfirm = (rule, value, callback) => {
      if (isEqual(this.popupType, 'add')) {
        if (isNil(value) || isEqual(value.length, 0)) {
          callback(new Error('필수 정보입니다.'));
        } else {
          const password = this.userInfoFormData.password;
          if (isNil(password) || isEqual(password.length, 0)) {
            callback(new Error('패스워드를 입력해주세요.'));
          }
          if (!isEqual(value, password)) {
            callback(new Error('패스워드가 일치하지 않습니다.'));
          }
        }
        callback();
      } else {
        callback();
      }
    };
    const validateEmailAddress = (rule, value, callback) => {
      if (isNil(value) || value === '') {
        callback();
      } else {
        // 2개 이상의 이메일 주소가 작성될 수 있도록 수정
        const emailArr = value.split(',');
        let isValid = true;
        emailArr.forEach((item) => {
          const replaceText = item;
          const validTest = validateEmailAddr(replaceText.replace(/^\s*/, ''), '');
          if (!validTest) {
            isValid = false;
          }
        });
        if (isValid) {
          callback();
        } else {
          callback(new Error('이메일 주소 형식을 확인해주세요.'));
        }
      }
    };
    return {
      columnDefault,
      managerTypeList: null,
      policyObject: {
        PASSWORDCHANGINGTYPE: 'PASSWORDINIT',
      },
      imgUrl: '',
      userInfoFormData: {
        managerId: null,
        managerName: null,
        managerType: null,
        password: null,
        passwordConfirm: null,
        managerPhoto: null,
        lockStatus: '0',
      },
      file: {},
      rules: {
        managerId: {
          required: true,
          validator: validateId,
          trigger: 'blur',
        },
        managerName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        managerType: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'change',
        },
        password: {
          required: true,
          validator: validatePassword,
          trigger: 'blur',
        },
        passwordConfirm: {
          required: true,
          validator: validatePasswordConfirm,
          trigger: 'blur',
        },
        email: {
          validator: validateEmailAddress,
          message: '이메일 형식이 올바르지 않습니다.',
          trigger: 'blur',
        },
      },
      columns: [
        {
          prop: 'ipaddress',
          label: '접근 허용 IP',
        },
        {
          scopedSlot: 'remove-slot',
          width: 50,
        },
      ],
      accessAllowIps: [],
      addAccessAllowIp: '',
    };
  },
  mounted() {
    BasicinfoSubAPI.getList('MANAGER_AUTH').then((response) => {
      this.managerTypeList = response.data.data;
    });
    UserSettingAPI.getAllAccountPolicyList().then((response) => {
      if (!isNil(response.data.data)) {
        response.data.data.forEach((item) => {
          const policyType = item.basicinfoSubid;
          const dataType = item.datatypeId;
          if (isEqual(dataType, 'STRING')) {
            this.policyObject[policyType] = item.basicinfoSubvalueString;
          } else if (isEqual(dataType, 'BOOL')) {
            this.policyObject[policyType] = Number(item.basicinfoSubvalueBoolean);
            if (isEqual(policyType, 'SECURITYWEAKPATTERNCHECK')) {
              this.policyObject.PATTERN = item.basicinfoSubvalueString;
            }
          } else if (isEqual(dataType, 'INTEGER')) {
            this.policyObject[policyType] = item.basicinfoSubvalueInteger;
          }
        });
      }
    });
  },
  methods: {
    clickManagerTypeInfo() {
      this.$emit('click-manager-type-info');
    },
    changeUserImage(file) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(file)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      // 이미지 확장자 파일인 경우에만 업로드
      if (!isImageFile(file)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_IMAGE_ONLY, false));
      } else {
        // 폼 데이터에 직접 바인딩을 해야 팝업에 나타남
        this.$set(this.userInfoFormData, 'managerPhoto', URL.createObjectURL(file.raw));
        this.$set(this.file, 'fileInfo', file.raw);
      }
    },
    resetFields() {
      this.$refs.userInfoForm.resetFields();
    },
    checkValidation() {
      return this.$refs.userInfoForm.validate();
    },
    getUserInfoFormData() {
      const ipList = this.accessAllowIps.map((item) => item.ipaddress);
      this.userInfoFormData.accessAllowIp = join(ipList, ',');
      return this.userInfoFormData;
    },
    initPassword() {
      this.$emit('init-password');
    },
    changePassword() {
      this.$emit('change-password', this.policyObject, this.userInfoFormData);
    },
    onAddAccessAllowIp() {
      this.validateIpaddress();
    },
    validateIpaddress() {
      const value = this.addAccessAllowIp;
      if (isNil(value)) {
        this.$message(msgUtil.getCustomMsgData('IP를 입력해주세요.'));
      } else if (validateIpv4(value) || validateIpv6(value)) {
        this.accessAllowIps.push({
          ipaddress: value,
        });
        this.addAccessAllowIp = '';
      } else {
        this.$message(msgUtil.getCustomMsgData('올바른 주소형식을 입력해주세요.'));
      }
    },
    onClickDeleteAccessAllowIp(row) {
      this.accessAllowIps.splice(row.$index, 1);
    },
  },
};
</script>
<style >
.myimage {
  width: 100% !important;
  height: 154px !important;
}
</style>
<style module>
.inline-block {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/components/UserInfoForm.vue